<script>

    import { toast } from 'bulma-toast'

    import StatisticsService from '../$services/statistics.service'
    import NumeralMethods from '../$methods/numeral.methods'

    import StatsCard from '../$components/stats.card.svelte'
    import Spinner from '../$components/spinner.svelte'

    export let dateStart = null
    export let dateEnd = null

    let loading = false
    let total = null

    $: if (dateStart && dateEnd)
        getShipmentsCanceled()

    async function getShipmentsCanceled() {
        loading = true
        total = null

        const resp = await StatisticsService.getShipmentsCanceled({
            dateStart: dateStart.toISOString(),
            dateEnd: dateEnd.toISOString(),
        })

        loading = false

        if (!resp.success)
            return toast({ message: resp.error.message, type: 'is-danger' })

        total = typeof resp.data === 'number'
            ? resp.data
            : (resp.data?.total ?? resp.data?.canceled ?? resp.data?.shipmentsCanceled ?? 0)
    }

</script>

<StatsCard icon="fa-ban" meta="Envíos" title="Envíos cancelados" {dateStart} {dateEnd}>
    <div>
        <Spinner {loading} />
        {#if !loading && total !== null}
            <p class="value is-danger">{ NumeralMethods.number(total) }</p>
            <p class="location">Cancelados en el periodo</p>
        {/if}
    </div>
</StatsCard>
